import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../components/Loader';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { IsOpen } from '../../../components/Icon';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE, REQUEST_VEHICLE_TASKS } from '../constants';
import { selectUserId, selectWork, selectWorks } from '../../Api/selectors';
import { selectVehicleTasks } from '../selectors';

import { selectActions } from '../../Actions/selectors';
import { fetchActions } from '../../Actions/actions';
import { REQUEST_ACTIONS } from '../../Actions/constants';
import { AppClientId } from '../../Shared/constants';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import env from '../../../env';
import cn from 'classnames';
import styles from './CardVehicleTasks.module.css';
import { KanbanVehicleRemarks } from '../../KanbanBoards/components/KanbanVehicleRemarks';

import { getRemarkType } from '../../KanbanBoards/cells/helpers/getRemarkType';

const Container = styled.div`
  font-size: 14px;



  .department {
    position: relative;
    height: 60px;
    width: 100%;
    padding: 5px;
    background-color: #eef1ef;
    border-radius: 0.375rem;
  }

  .tasks-list {
    margin: 10px;
  }
  align-items: center;
  .task-cell {
    height: 60px;
  }

  .toggle-icon {
    position: absolute;
    right: 5px;
  }
`;

const STATE = {
  tasks: [],
  isOpen: true,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleTasksRemarksCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetchActions();
    this.allVehicleTasks.map(t => {
      if (this.isTaskWithRemarks(t.name) && !this.state[`show_${t.name}`]) {
        this.setState({ [`show_${t.name}`]: true });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    this.allVehicleTasks?.map(t => {
      if (this.isTaskWithRemarks(t.name) && this.state[`show_${t.name}`] === undefined) {
        this.toggleDepartmentItemShow(t?.name);
      }
    });
  }

  isTaskWithRemarks(task) {
    const taskRemarksProp = getRemarkType(task);
    if (this.props.vehicle[taskRemarksProp]) return true;
    return false;
  }

  get allVehicleTasks() {
    const allTasks = Object.entries(this.props.tasks).filter(
      ([department, tasks]) =>
        (env.clientId === AppClientId.HOOIKAMMER && department.includes('HOOIKAMMER')) ||
        (env.clientId === AppClientId.AUTOWIENTJES && department.includes('werkzaamheden_wientjes')) ||
        (env.clientId === AppClientId.INDEWAL &&
          [
            'Technische_dienst',
            'Walstreet',
            'Importadministratie',
            'Finance_inkoop',
            'Finance_verkoop',
            'Transport inkomend',
            'Verkoopadministratie',
            'Inkoopadministratie',
            'Commercie',
            'Transport uitgaand',
          ].includes(department)) ||
        (env.clientId === AppClientId.HILTERMANN &&
          ['HILT_R_R', 'HILT_Logistiek', 'HILT_Debiteuren', 'HILT_Overig'].includes(department)),
    );
    const tempObject = Object.fromEntries(allTasks);
    const tasks = Object.values(tempObject).flat();

    return tasks;
  }

  toggleDepartmentItemShow(department) {
    this.state[`show_${department}`]
      ? this.setState({ [`show_${department}`]: false })
      : this.setState({ [`show_${department}`]: true });
  }

  renderRemarks(task) {
    return this.props.workRemarks ? (
      <Loader small />
    ) : (
      <KanbanVehicleRemarks
        readOnly
        vehicleTaskRemarks
        taskName={task}
        vehicleId={this.props.vehicle.id}
        loggedUserId={this.props.loggedInUser}
        fetchedVehicle={this.props.vehicle}
      />
    );
  }

  render() {
    if (this.props.work) return <LoadingDetailsPageCard />;

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container id={'CardVehicleTasksRemarks'}>
          <HBox className={styles.titleBox}>
            <h2 className="card-title mb-0 text-muted" style={{ whiteSpace: 'nowrap' }}>
              {this.lbl('vehicle.info.tasks.task_remarks_overview')}
            </h2>

            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
              
            </div>
          </HBox>
          {this.state.isOpen && (
            <>
              <List>
                {this.allVehicleTasks.map(task => {
                   const modifiedName = task?.name?.replace("HOOI_NEW_", "hooi_new_task_");
                   const translation = task?.name
                   
                  return (
                    
                    this.isTaskWithRemarks(modifiedName) && (
              
                      
                      <Row key={`task-${modifiedName}`}>
                      
                        <Cell className="task-cell">
                          <HBox className="department" vCenter left>
                            <strong style={{ margin: '5px', width: '40%' }}>
                              {this.lbl(`vehicle.property.${translation}`)}
                            </strong>

                            <div className={'toggle-icon'} onClick={() => this.toggleDepartmentItemShow(modifiedName)}>
                              <IsOpen />
                            </div>
                          </HBox>
                          {this.state[`show_${modifiedName}`] && (
                            <HBox key={modifiedName}>{this.renderRemarks(modifiedName)}</HBox>
                          )}
                        </Cell>
                      </Row>
                    )
                  );
                })}
              </List>
            </>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleTasksRemarksCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks(REQUEST_VEHICLE_TASKS, REQUEST_ACTIONS, REQUEST_VEHICLE),
    tasks: selectVehicleTasks(),
    actions: selectActions(),
    loggedInUser: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,

    fetchActions() {
      dispatch(fetchActions());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleTasksRemarksCard = compose(withConnect, withRouter)(VehicleTasksRemarksCardComp);
